
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_2","data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Layer_1","data-name":"Layer 1"}},[_c('path',{attrs:{"id":"Path_20098","data-name":"Path 20098","d":"M15.81 9.15a1.81 1.81 0 00-.61.1V7.64a1.94 1.94 0 00-1.93-1.93 1.86 1.86 0 00-.95.26 1.93 1.93 0 00-3.49.78 1.72 1.72 0 00-.64-.11 1.93 1.93 0 00-1.93 1.93v4.55a5.74 5.74 0 1011.48 0v-2a1.93 1.93 0 00-1.93-1.97zm.6 4a4.41 4.41 0 01-8.82 0V8.57a.61.61 0 111.21 0v3.75a.66.66 0 001.32 0V7.07a.61.61 0 111.22 0v5.25a.66.66 0 101.32 0V7.64a.6.6 0 01.61-.6.61.61 0 01.61.6v4.68a.66.66 0 001.32 0v-1.24a.61.61 0 111.21 0z","fill":"#fe902c"}}),_c('g',{attrs:{"id":"Group_23503","data-name":"Group 23503"}},[_c('g',{attrs:{"id":"Ellipse_140","data-name":"Ellipse 140","fill":"none"}},[_c('circle',{attrs:{"id":"Ellipse_349","data-name":"Ellipse 349","cx":"12","cy":"12","r":"12"}}),_c('circle',{attrs:{"id":"Ellipse_350","data-name":"Ellipse 350","cx":"11.5","cy":"11.5","r":"11.5","transform":"translate(.5 .5)","stroke":"#fe902c","stroke-width":"1"}})])])])])
          )
        }
      }
    